import { render, staticRenderFns } from "./productStockling.vue?vue&type=template&id=742fc1f9&"
import script from "./productStockling.vue?vue&type=script&lang=js&"
export * from "./productStockling.vue?vue&type=script&lang=js&"
import style0 from "./productStockling.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports